<script lang="ts">
	import { HERO_ORANGE } from '$lib/colors'

	interface Props {
		width?: number
		height?: number
		animate?: boolean
		fill?: string | null
		inverted?: boolean
	}

	let {
		width = 243,
		height = (width * 22) / 81,
		animate = false,
		fill = null,
		inverted = false
	}: Props = $props()
	let orange = $derived(inverted ? 'white' : HERO_ORANGE)
	let modifiedFill = $derived(fill ?? (inverted ? 'black' : 'var(--text)'))
</script>

<svg
	class="logo"
	class:logo-animate={animate}
	{width}
	{height}
	viewBox="0 0 243 66"
	fill="none"
	role="img"
	xmlns="http://www.w3.org/2000/svg"
>
	<title>PauseAI logo</title>
	<path
		class="logo-circle"
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M66 33C66 51.2254 51.2254 66 33 66C14.7746 66 0 51.2254 0 33C0 14.7746 14.7746 0 33 0C51.2254 0 66 14.7746 66 33ZM20.7902 18.8101H29.0402V48.1801H20.7902V18.8101ZM44.5504 18.8101H36.3004V48.1801H44.5504V18.8101Z"
		fill={orange}
	/>
	<path
		class="logo-pause"
		d="M54.6042 47V19H68.0842C70.6976 19 72.9509 19.4267 74.8442 20.28C76.7642 21.1333 78.2442 22.36 79.2842 23.96C80.3242 25.5333 80.8442 27.4 80.8442 29.56C80.8442 31.72 80.3242 33.5867 79.2842 35.16C78.2442 36.7333 76.7642 37.96 74.8442 38.84C72.9509 39.6933 70.6976 40.12 68.0842 40.12H59.8442L64.0442 36.08V47H54.6042ZM64.0442 37.12L59.8442 32.84H67.4842C68.7909 32.84 69.7509 32.5467 70.3642 31.96C71.0042 31.3733 71.3242 30.5733 71.3242 29.56C71.3242 28.5467 71.0042 27.7467 70.3642 27.16C69.7509 26.5733 68.7909 26.28 67.4842 26.28H59.8442L64.0442 22V37.12ZM79.4939 47L91.7339 19H101.014L113.254 47H103.494L94.4539 23.48H98.1339L89.0939 47H79.4939ZM86.7739 42.12L89.1739 35.32H102.054L104.454 42.12H86.7739ZM127.575 47.64C123.281 47.64 119.935 46.48 117.535 44.16C115.135 41.84 113.935 38.5867 113.935 34.4V19H123.375V34.12C123.375 36.2533 123.761 37.7733 124.535 38.68C125.308 39.56 126.348 40 127.655 40C128.988 40 130.028 39.56 130.775 38.68C131.548 37.7733 131.935 36.2533 131.935 34.12V19H141.215V34.4C141.215 38.5867 140.015 41.84 137.615 44.16C135.215 46.48 131.868 47.64 127.575 47.64ZM155.982 47.64C153.635 47.64 151.368 47.3733 149.182 46.84C146.995 46.3067 145.195 45.6133 143.782 44.76L146.822 37.88C148.155 38.6533 149.635 39.28 151.262 39.76C152.915 40.2133 154.515 40.44 156.062 40.44C156.968 40.44 157.675 40.3867 158.182 40.28C158.715 40.1467 159.102 39.9733 159.342 39.76C159.582 39.52 159.702 39.24 159.702 38.92C159.702 38.4133 159.422 38.0133 158.862 37.72C158.302 37.4267 157.555 37.1867 156.622 37C155.715 36.7867 154.715 36.5733 153.622 36.36C152.528 36.12 151.422 35.8133 150.302 35.44C149.208 35.0667 148.195 34.5733 147.262 33.96C146.355 33.3467 145.622 32.5467 145.062 31.56C144.502 30.5467 144.222 29.2933 144.222 27.8C144.222 26.0667 144.702 24.4933 145.662 23.08C146.648 21.64 148.102 20.4933 150.022 19.64C151.968 18.7867 154.382 18.36 157.262 18.36C159.155 18.36 161.022 18.56 162.862 18.96C164.702 19.36 166.355 19.9733 167.822 20.8L164.982 27.64C163.595 26.9467 162.248 26.4267 160.942 26.08C159.662 25.7333 158.408 25.56 157.182 25.56C156.275 25.56 155.555 25.64 155.022 25.8C154.488 25.96 154.102 26.1733 153.862 26.44C153.648 26.7067 153.542 27 153.542 27.32C153.542 27.8 153.822 28.1867 154.382 28.48C154.942 28.7467 155.675 28.9733 156.582 29.16C157.515 29.3467 158.528 29.5467 159.622 29.76C160.742 29.9733 161.848 30.2667 162.942 30.64C164.035 31.0133 165.035 31.5067 165.942 32.12C166.875 32.7333 167.622 33.5333 168.182 34.52C168.742 35.5067 169.022 36.7333 169.022 38.2C169.022 39.9067 168.528 41.48 167.542 42.92C166.582 44.3333 165.142 45.48 163.222 46.36C161.302 47.2133 158.888 47.64 155.982 47.64ZM180.471 29.4H192.951V36.2H180.471V29.4ZM181.111 39.88H195.111V47H171.831V19H194.591V26.12H181.111V39.88Z"
		fill="black"
		style={modifiedFill ? `fill: ${modifiedFill}` : ''}
	/>
	<path
		class="logo-ai"
		d="M195.705 47L207.945 19H217.225L229.465 47H219.705L210.665 23.48H214.345L205.305 47H195.705ZM202.985 42.12L205.385 35.32H218.265L220.665 42.12H202.985ZM230.971 47V19H240.411V47H230.971Z"
		fill={orange}
	/>
</svg>

<style>
	.logo-pause {
		fill: var(--text);
	}
	.logo {
		width: 100%;
		overflow: visible;
	}
	.logo-circle {
		transform: translateX(-2px);
		transform-origin: center;
	}
	.logo-animate:hover {
		transform: scale(1.05);
	}
	.logo {
		transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
	}
	.logo-animate:active .logo-circle {
		fill: var(--brand-subtle);
	}
</style>
